import { useDocumentMeta } from "hooks/useDocumentMeta";
import { useSiteTitle } from "hooks/useSiteTitle";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PathName } from "routers/types";
import Header from "../components/Header/Header";
import { useData } from "data/data-provider";

let OPTIONS = {
  root: null,
  rootMargin: "0px",
  threshold: 1.0,
};
let OBSERVER: IntersectionObserver | null = null;
const PAGES_HIDE_HEADER_BORDER: PathName[] = ["/home", "/listing-car-detail"];

const SiteHeader = () => {
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [isTopOfPage, setIsTopOfPage] = React.useState(window.pageYOffset < 5);
  const location = useLocation();
  const { companyDetails } = useData();

  const intersectionCallback = (entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      setIsTopOfPage(entry.isIntersecting);
    });
  };

  useEffect(() => {
    // disconnect the observer
    if (!PAGES_HIDE_HEADER_BORDER.includes(location.pathname as PathName)) {
      OBSERVER && OBSERVER.disconnect();
      OBSERVER = null;
      return;
    }
    if (!OBSERVER) {
      OBSERVER = new IntersectionObserver(intersectionCallback, OPTIONS);
      anchorRef.current && OBSERVER.observe(anchorRef.current);
    }
  }, [location.pathname]);

  let headerClassName = "shadow-sm dark:border-b dark:border-neutral-700";
  if (PAGES_HIDE_HEADER_BORDER.includes(location.pathname as PathName)) {
    headerClassName = isTopOfPage
      ? ""
      : "shadow-sm dark:border-b dark:border-neutral-700";
  }
  // The operator's SEO title, then their name, on every route (1NOW-11189); a page
  // that sets its own title wins. See useSiteTitle.
  useSiteTitle(companyDetails);
  // 1NOW-1645 — description, social-share and canonical tags, from the same
  // tenant payload. The header renders on every page, so this covers the site.
  useDocumentMeta(companyDetails);
  return (
    <>
      <Header className={headerClassName} navType="MainNav1" />
      <div ref={anchorRef} className="h-1 absolute invisible"></div>
    </>
  );
};

export default SiteHeader;
